import React, { useState, useRef, useEffect } from "react";
import { Offcanvas, Dropdown, Button } from "react-bootstrap";
import chevron_down from "../../../assets/Vehicles/chevron_down.png";
import upload from "../../../assets/Vehicles/file.png";
import { Calendar } from "lucide-react";
import DatePicker from "react-datepicker";
import CommonDropdown from "../../common/common_dropDown";
import { submitRenewalAPI, updateRenewalAPI, getVehicleDetailsApi, getRenewalEditApi, saveAttachmentApi } from "../renewal-api";
import ErrorExtractor from "../../common/error_extractor";
import DOMPurify from "dompurify";
import MultiSelectDropDown from "../../common/multi-select-dropdown";
import { DocUploader } from "../../common/DocUploader";
import attachment from "../../../assets/png/attachment.png";
import download from "../../../assets/svg/download.svg";
import closeAttachment from "../../../assets/svg/close-red.svg";

export const AddRenewal = ({ id, show, handleClose }) => {
  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [removedAttachmentList, setRemovedAttachmentList] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [selectedDate, setSelectedDate] = useState();

  const apiUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    if (id != null) {
      getRenewalEdit(id);
    }
  }, [id]);
  const resetForm = () => {
    setRenewalId(null);
    setLicensePlateOption(null);
    setVehicleName("");
    setVehicleIdentificationNumber("");
    setRenewalNameOption(null);
    setVendorOption(null);
    setRenewalPeriod("");
    setImage("");
    setRenewalPeriodType("Month");
    setDescription("");
    setSelectedAlertOptions([]);
    setSelectedDate(null);
    setAttachmentList([]);
    setAttachmentURLList([]);
    setRemovedAttachmentList([]);
    setErrorMsg({
      vehicle_id: "",
      vendor_id: "",
      renewal_name: "",
      days: "",
      renewal_period: "",
      period_type: "",
      end_date: "",
      description: "",
      images: "",
    });
  };
  const alertDays = [
    { label: "Before 1 days", value: "1" },
    { label: "Before 2 days", value: "2" },
    { label: "Before 4 days", value: "4" },
    { label: "Before 10 days", value: "10" },
  ];
  const [renewalId, setRenewalId] = useState("");
  const [licensePlateOption, setLicensePlateOption] = useState(null);
  const [vehicleName, setVehicleName] = useState("");
  const [vehicleIdentificationNumber, setVehicleIdentificationNumber] = useState("");
  const [renewalNameOption, setRenewalNameOption] = useState("");
  const [vendorOption, setVendorOption] = useState(null);
  const [renewalPeriod, setRenewalPeriod] = useState("");
  const [renewalPeriodType, setRenewalPeriodType] = useState("Month");
  const [description, setDescription] = useState("");
  const [selectedAlertOptions, setSelectedAlertOptions] = useState([]);

  const handleSelectVehicle = (item) => {
    setLicensePlateOption(item);
    getVehicleDetails(item.value);
  };
  const getVehicleDetails = async (id) => {
    try {
      const response = await getVehicleDetailsApi(id);
      console.log(response.data);
      if (response.data.success === true) {
        setVehicleName(response.data.vehicle?.name ?? "");
        setVehicleIdentificationNumber(response.data.vehicle?.vin ?? "");
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handleSelectRenewal = (item) => {
    setRenewalNameOption(item);
  };
  const handleSelectVendor = (item) => {
    setVendorOption(item);
  };
  const handleAlertDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    const index = selectedAlertOptions.findIndex((option) => option.value === selectedOptions.value);
    console.log(selectedAlertOptions);
    if (index > -1) {
      const updatedOptions = selectedAlertOptions.filter((option) => option.value !== selectedOptions.value);
      setSelectedAlertOptions(updatedOptions);
    } else {
      setSelectedAlertOptions([...selectedAlertOptions, selectedOptions]);
    }
  };
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const [errorMsg, setErrorMsg] = useState({
    vehicle_id: "",
    vendor_id: "",
    renewal_name: "",
    days: "",
    renewal_period: "",
    period_type: "",
    end_date: "",
    description: "",
    images: "",
  });

  const submitForm = async () => {
    const extractor = new ErrorExtractor();
    setLoading(true);
    try {
      const preSanitizeData = {
        vehicle_id: licensePlateOption != null ? licensePlateOption.value : "",
        vendor_id: vendorOption != null ? vendorOption.value : "",
        renewal_name: renewalNameOption != null ? renewalNameOption : "",
        period_type: renewalPeriodType,
        renewal_period: renewalPeriod,
        end_date: selectedDate != null && selectedDate !== "" ? selectedDate.toLocaleDateString("en-CA") : "",
        days: selectedAlertOptions.filter((item) => item.value !== "").map((item) => item.value),
        description: description,
        removed_images: removedAttachmentList ?? [],
        images: [],
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitRenewalAPI(sanitizedData);
      } else {
        response = await updateRenewalAPI(id, sanitizedData);
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            vehicle_id: "",
            vendor_id: "",
            renewal_name: "",
            days: "",
            renewal_period: "",
            period_type: "",
            end_date: "",
            description: "",
            images: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            if (key === "items") {
              validationTemp[key] = value;
            } else {
              validationTemp[key] = value.length === 0 ? "" : value[0];
            }
          });
          console.log("validationTemp...", validationTemp);

          setErrorMsg(validationTemp);
        });
        setLoading(false);
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        if (attachmentList.length === 0) {
          handleClose(response.data);
          resetForm();
          setLoading(false);
        } else {
          saveAttachment(response.data.id);
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
      setLoading(false);
    }
  };
  const saveAttachment = async (workOrderId) => {
    try {
      const data = {
        attachment: attachmentList.map((item) => item.base64),
      };
      const response = await saveAttachmentApi(workOrderId, data);
      if (response.data.success === true) {
        handleClose(response.data);
        resetForm();
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };

  const getRenewalEdit = async (id) => {
    try {
      const response = await getRenewalEditApi(id);

      if (response.data.success === true) {
        const renewalDetail = response.data.renewal ?? {};

        setRenewalId(renewalDetail.renewal_id ?? "");
        setLicensePlateOption({
          value: renewalDetail.vehicle_id ?? "",
          label: renewalDetail.lic_no ?? "",
        });
        setVehicleName(renewalDetail.vehicle_name ?? "");
        setVehicleIdentificationNumber(renewalDetail.vin ?? "");
        setVendorOption({
          value: renewalDetail.vendor_id ?? "",
          label: renewalDetail.vendor ?? "",
        });
        setRenewalNameOption(renewalDetail.renewal_name ?? "");
        setRenewalPeriodType(renewalDetail.period_type);
        setRenewalPeriod(renewalDetail.renewal_period);
        setSelectedDate(renewalDetail.end_date != null && renewalDetail.end_date !== "" ? new Date(renewalDetail.end_date) : null);
        setAttachmentURLList(renewalDetail.images ?? []);
        setDescription(renewalDetail.description ?? "");

        if (Array.isArray(renewalDetail.days)) {
          const mapped = renewalDetail.days
            .map((d) => {
              const strVal = String(d);
              const match = alertDays.find((a) => a.value === strVal);
              return match ?? { value: strVal, label: `Before ${strVal} days` };
            })
            .filter((v, i, arr) => arr.findIndex((x) => x.value === v.value) === i);
          setSelectedAlertOptions(mapped);
        } else {
          setSelectedAlertOptions([]);
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handleCloseWithReset = () => {
    resetForm(); // Reset form state
    handleClose(); // Close the Offcanvas
  };
  return (
    <Offcanvas show={show} onHide={handleCloseWithReset} placement="end">
      <Offcanvas.Header closeButton={false} className="d-flex justify-content-between align-items-center">
        <Offcanvas.Title>New Renewal</Offcanvas.Title>
        <button
          onClick={handleCloseWithReset}
          style={{
            backgroundColor: "transparent",
            border: "2px solid #D4DDE7",
            color: "#172B4D",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          X
        </button>
      </Offcanvas.Header>
      <hr />
      <Offcanvas.Body className="pt-0">
        <div className="row p-2">
          <div className="p-3">
            <DocUploader
              label="Upload document"
              description="Add a document here by dragging and dropping, or choose files manually."
              onFileSelect={(file) => {
                if (file) {
                  const reader = new FileReader();
                  reader.onload = async () => {
                    const base64String = await reader.result;
                    setAttachmentList([
                      ...attachmentList,
                      {
                        name: file.name,
                        base64: base64String,
                        size: formatBytes(file.size),
                      },
                    ]);
                  };
                  reader.readAsDataURL(file);
                }
              }}
            />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.images}
            </span>
            {attachmentURLList.length > 0 && (
              <div
                style={{
                  marginTop: "16px",
                  marginBottom: "16px",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "16px",
                }}
              >
                {attachmentURLList.map((item, attachIndex) => (
                  <div
                    style={{
                      width: "312px",
                      height: "62px",
                      borderRadius: "12px",
                      padding: "12px 16px 12px 16px",
                      backgroundColor: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img src={attachment} style={{ width: "37px", height: "36px" }} />
                    <div
                      style={{
                        width: "240px",
                        marginLeft: "8px",
                        marginTop: "4px",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "500px",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "2px",
                        }}
                      >
                        {item.name}
                      </span>
                      <br />
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "400px",
                          fontSize: "12px",
                          lineHeight: "16.2px",
                          color: "#8790A1",
                        }}
                      >
                        {item.size}
                      </p>
                    </div>

                    {item.url && (
                      <div
                        onClick={() => {
                          downloadFile(item.url, item.url.split("/").pop());
                        }}
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "100px",
                        }}
                      >
                        <img
                          src={download}
                          style={{
                            width: "12.8px",
                            height: "12px",
                            top: "10px",
                            left: "9.6px",
                          }}
                        />
                      </div>
                    )}

                    <div
                      style={{
                        position: "relative",
                        width: "32px",
                        height: "32px",
                        borderRadius: "100px",
                        marginLeft: "4px",
                      }}
                    >
                      <img
                        src={closeAttachment}
                        style={{
                          width: "12.8px",
                          height: "12px",
                          top: "10px",
                          left: "9.6px",
                        }}
                        alt="remove"
                        onClick={() => {
                          /* removeAttachment(item.id); */
                          setRemovedAttachmentList([...removedAttachmentList, item.id]);
                          setAttachmentURLList(attachmentURLList.filter((_, i) => i !== attachIndex));
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
            {attachmentList.length > 0 && (
              <div
                style={{
                  marginTop: "16px",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  gap: "16px",
                }}
              >
                {attachmentList.map((item, attachIndex) => (
                  <div
                    style={{
                      width: "312px",
                      height: "62px",
                      borderRadius: "12px",
                      padding: "12px 16px 12px 16px",
                      backgroundColor: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img src={attachment} style={{ width: "37px", height: "36px" }} />
                    <div
                      style={{
                        width: "210px",
                        marginLeft: "8px",
                        marginTop: "4px",
                      }}
                    >
                      <div
                        style={{
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          fontWeight: "500px",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "2px",
                        }}
                      >
                        {item.name}
                      </div>
                      <p
                        style={{
                          fontWeight: "400px",
                          fontSize: "12px",
                          lineHeight: "16.2px",
                          color: "#8790A1",
                        }}
                      >
                        {item.size}
                      </p>
                    </div>

                    <div
                      style={{
                        position: "relative",
                        width: "32px",
                        height: "32px",
                        borderRadius: "100px",
                        marginLeft: "4px",
                      }}
                    >
                      <img
                        src={closeAttachment}
                        style={{
                          width: "12.8px",
                          height: "12px",
                          top: "10px",
                          left: "9.6px",
                        }}
                        onClick={() => {
                          setAttachmentList(attachmentList.filter((_, i) => i !== attachIndex));
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <p style={{ color: "#172B4D" }} className="fs-16 fw-600 mt-3">
            Renewal details
          </p>
          {id !== null && (
            <div className="col-xl-6">
              <label htmlFor="fill" className="form-label  fw-400">
                Renewal ID
              </label>
              <input type="text" className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Auto-fill" value={renewalId} readOnly={true} />
            </div>
          )}
          <div className="col-6">
            <label htmlFor="vin" className="form-label fw-400 d-flex">
              License Plate<span className="error-text">*</span>
            </label>
            <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select vehicle" value={licensePlateOption} onSelect={handleSelectVehicle} />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.vehicle_id}
            </span>
          </div>

          {/* Your existing form fields */}
          <div className="col-xl-6">
            <label htmlFor="vehicleName" className="form-label fw-400">
              Vehicle name
            </label>
            <input type="text" className="form-control rounded-3 vehicle-form-input" id="vehicleName" value={vehicleName} readOnly={true} />
          </div>
          <div className="col-xl-6">
            <label htmlFor="plate" className="form-label fw-400">
              Vehicle Identification Number (VIN)
            </label>
            <input type="text" className="form-control rounded-3 vehicle-form-input" id="plate" placeholder="Auto-fill" value={vehicleIdentificationNumber} readOnly={true} />
          </div>
          <div className="col-xl-6 mt-2">
            <label htmlFor="fill" className="form-label  fw-400">
              Renewal Name
            </label>
            {/* <CommonDropdown apiUrl={`${apiUrl}get_renewals`} placeholder="Select Renewal" value={renewalNameOption} onSelect={handleSelectRenewal} />{" "} */}
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="Enter here..."
              value={renewalNameOption}
              onChange={(e) => {
                setRenewalNameOption(e.target.value);
              }}
            />{" "}
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.renewal_name}
            </span>
          </div>
          <div className="col-xl-6 mt-2">
            <label htmlFor="type" className="form-label fw-400 d-flex">
              Vendor<span className="error-text">*</span>
            </label>
            <CommonDropdown apiUrl={`${apiUrl}get_vendors`} placeholder="Select Vendor" value={vendorOption} onSelect={handleSelectVendor} />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.vendor_id}
            </span>
          </div>
          <div className="col-xl-6 mt-2">
            <label htmlFor="makeinfo" className="form-label  fw-400 d-flex">
              Renewal period<span className="error-text">*</span>
            </label>
            <div className="d-flex border rounded-3 px-1">
              <input
                type="text"
                className="form-control border-0 rounded-0 border-end vehicle-form-input"
                id="makeinfo"
                value={renewalPeriod}
                maxLength={6}
                placeholder="Enter here..."
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setRenewalPeriod(value);
                }}
              />
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic" className=" bg-transparent w-100 text-black d-flex justify-content-between border-0 border-start gap-3 rounded-0 dp-toggle">
                  <span className="text-black">
                    {renewalPeriodType}
                    <img src={chevron_down} alt="down" />
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                  <Dropdown.Item onClick={() => setRenewalPeriodType("Month")}>Month</Dropdown.Item>
                  <Dropdown.Item onClick={() => setRenewalPeriodType("Year")}>Year</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.renewal_period}
            </span>
          </div>
          <div className="col-xl-6 d-flex flex-column  mt-3">
            <label htmlFor="date" className="form-label fw-400 d-flex">
              End Date<span className="error-text">*</span>
            </label>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              dateFormat="yyyy-MM-dd"
              customInput={
                <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                  {selectedDate ? selectedDate.toLocaleDateString() : <span style={{ color: "#8790A1" }}>mm/dd/yyyy</span>}
                  <Calendar size={16} />
                </button>
              }
            />
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.end_date}
            </span>
          </div>

          <div className="col-xl-6">
            <label htmlFor="type" className="form-label fw-400 mt-3">
              Alert Scheduler
            </label>
            <MultiSelectDropDown onDropdownChange={handleAlertDropdownChange} placeholder={"Alert"} selectedOption={selectedAlertOptions} staticOptions={alertDays} />
          </div>
          <div className="col-xl-6">
            <label htmlFor="type" className="form-label fw-400 mt-3">
              Description
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="Enter here..."
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />{" "}
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.description}
            </span>
          </div>
          <div className="d-flex gap-3 justify-content-end mt-5">
            <Button className="bg-white rounded-3 px-4 py-2 pagination-color btn-border-grey" onClick={handleCloseWithReset}>
              Cancel
            </Button>
            <Button onClick={submitForm} className="dark-purple-btn rounded-3 py-2 px-4" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                </>
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
